import { ReactElement } from 'react'
import {
  GetStaticPathsContext,
  GetStaticPropsContext,
  InferGetStaticPropsType
} from 'next'

import Meta from '@/components/base/meta'
import PageBuilder from '@/components/layout/builder'
import Layout from '@/components/layout/layout'
import { mapPageStaticProps } from '@/utils/pageData'
import { getPromiseFromFetch } from '@/utils/request'
import { API, MOCK_DATA } from '@/constants'

import { WPPageData, WPRoutes } from '@/types'

export default function Page(
  pageProps: InferGetStaticPropsType<typeof getStaticProps>
) {
  return <PageBuilder pageProps={pageProps} />
}

Page.getLayout = function getLayout(page: ReactElement, pageProps: WPPageData) {
  return (
    <Layout pageProps={pageProps}>
      <Meta pageProps={pageProps} />
      {page}
    </Layout>
  )
}

export async function getStaticProps({
  params,
  locale,
  defaultLocale
}: GetStaticPropsContext<{ routes: string[] }>) {
  const res = MOCK_DATA
    ? {
        data: require(`@/data/pages/${params?.routes.join('/')}.json`),
        status: 200
      }
    : await getPromiseFromFetch<WPPageData>({
        method: 'get',
        url: `/${locale === defaultLocale ? '' : `${locale}/`}${params?.routes.join('/')}/`
      })

  if (locale === 'default' || res.status === 404) return { notFound: true }

  const { data: pageProps } = res

  return {
    props: {
      ...(await mapPageStaticProps(pageProps, locale))
    }
  }
}

export async function getStaticPaths({ defaultLocale }: GetStaticPathsContext) {
  const { data: routes } = MOCK_DATA
    ? { data: require('@/data/routes.json') as WPRoutes }
    : await getPromiseFromFetch<WPRoutes>({
        method: 'get',
        url: API.ROUTES
      })

  return {
    paths: routes.map((route) => ({
      params: { routes: route.routes.filter((item) => item !== route.locale) },
      locale: route.locale === defaultLocale ? '' : route.locale
    })),
    fallback: 'blocking' // false
  }
}
